module.exports = __webpack_public_path__ + "img/1.e43c3c7f.png";